import { CQ_ACTION_CODES } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.se.risk.subject]: 'TELCOBI Tarifas Moviles Riesgo Error 800',
      [STRING_KEYS.se.order.subject]: 'TELCOBI Tarifas Moviles Error TELCO',
      [STRING_KEYS.shipment.text]: 'Recibirás la tarjeta SIM en un plazo de 48h en la dirección que nos indiques.',
      [STRING_KEYS.shipment.secondaryText]: '',
      [STRING_KEYS.stepTitles.mainAction]: 'Indica cómo quieres configurar esta tarifa',
      [STRING_KEYS.summary.mobileLineAction.title]: 'Línea móvil',
      [STRING_KEYS.summary.mobileLineAction.multipleActionsTitle]: 'Líneas móviles',
      [STRING_KEYS.summary.shipment.title]: 'Envío SIMs',
      [STRING_KEYS.summary.shipment.text]: 'Recibirás la tarjeta SIM en un plazo de 48h.',
      [STRING_KEYS.summary.shipment.secondaryText]: '',
      [STRING_KEYS.provisionalAgreement.title]: '',
      [STRING_KEYS.provisionalAgreement.pdfLinkText]: 'Descarga del resumen del contrato (PDF).',

      [STRING_KEYS.retargeting.id]: 'ret-lm-cart',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
      [STRING_KEYS.summary.mainActionSelected.value]: 'Número nuevo',
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
      [STRING_KEYS.summary.mainActionSelected.value]: 'Portabilidad: {phoneNumber}',
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
      [STRING_KEYS.summary.mainActionSelected.value]: '{phoneNumber}',
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
      [STRING_KEYS.summary.secondaryAction[CQ_ACTION_CODES.REGISTER]]: 'Número nuevo',
      [STRING_KEYS.summary.secondaryAction[CQ_ACTION_CODES.PORTABILITY]]: 'Portabilidad: ',
      [STRING_KEYS.summary.secondaryAction[CQ_ACTION_CODES.MIGRATION]]: '',
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  selfEmployed: {
    everyMainSelection: {
      [STRING_KEYS.se.risk.subject]: 'TELCOBI Tarifas Moviles Riesgo Error 800 AU',
      [STRING_KEYS.se.order.subject]: 'TELCOBI Tarifas Moviles Error TELCO AU',
    },
  },
};
